/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import ProfilePageSidebarPropTypes from './Profile.page.sidebar.props';
import profilePageStyles from './Profile.page.styles';

/**
 * ProfilePageSidebarComponent
 * @export
 * @class ProfilePageSidebarComponent
 * @extends {React.Component<ProfilePageSidebarComponentComposedProps, ProfilePageSidebarComponentState>}
 */
export class ProfilePageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ProfilePageSidebarComponentProps>}
   * @memberof ProfilePageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ProfilePageSidebar`}
   * @memberof ProfilePageSidebarComponent
   */
  static displayName = `ProfilePageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ProfilePageSidebarComponent
   */
  static propTypes = ProfilePageSidebarPropTypes;

  /**
   * Data specific to the `<ProfilePageSidebar />` instance
   * @type {ProfilePageSidebarComponentState}
   * @memberof ProfilePageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<ProfilePageSidebar />`
   * @memberof ProfilePageSidebarComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<ProfilePageSidebarComponentProps>} */
const ProfilePageSidebar = compose(withStyles(themeCreateInjectableStyles(profilePageStyles), { withTheme: true }))(ProfilePageSidebarComponent);

export default ProfilePageSidebar;
